export enum DictionaryKeys {
  GiftBoxCategories = 'GiftboxCategories',
  DeliveryMethods = 'DeliveryMethods'
}
